import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {ReactiveFormsModule} from "@angular/forms";
import {ErrorModule} from "../errors/error.module";
import {DartDealImportDirective} from "./dartDealImport-link.directive";
import {DartDealImportDialogComponent} from "./dartDealImport-dialog.component";
import {MdProgressSpinnerModule} from "../misc/progress-spinner";
import {HttpClientModule} from "@angular/common/http";

@NgModule({
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    ErrorModule,
    MdProgressSpinnerModule,
    HttpClientModule,
  ],
  declarations: [
    DartDealImportDirective,
    DartDealImportDialogComponent,
  ],
  entryComponents: [
    DartDealImportDialogComponent,
  ],
  exports: [
    DartDealImportDirective,
  ],
})
export class DartDealImportModule {
}
